import { render, staticRenderFns } from "./ImportRunDetail.vue?vue&type=template&id=bbe8058c"
import script from "./ImportRunDetail.vue?vue&type=script&lang=js"
export * from "./ImportRunDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports